import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getLang } from '../i18n';

const API_URL = process.env.REACT_APP_API_URL || '/api';
const ui = (de, en) => (getLang() === 'en' ? en : de);

function normalizeMessage(value) {
  return String(value || '').trim();
}

export function PortalLoginRequest() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setMessage('');
    setError('');

    try {
      const response = await fetch(`${API_URL}/portal/login/request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const payload = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(payload.error || ui('Login-Link konnte nicht verschickt werden.', 'The login link could not be sent.'));
      }

      setMessage(payload.message || ui('Falls ein Business Hub existiert, wurde ein Login-Link verschickt.', 'If a Business Hub exists, a login link has been sent.'));
      setEmail('');
    } catch (err) {
      console.error(err);
      setError(err.message || ui('Login-Link konnte nicht verschickt werden.', 'The login link could not be sent.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="page-shell portal-login-page">
      <div className="brand-header">
        <div>
          <p className="eyebrow">YourGermanAddress</p>
          <h1>{ui('Kundenportal', 'Customer portal')}</h1>
          <p className="subtitle">
            {ui('Fordern Sie Ihren sicheren Zugangslink an und setzen Sie Ihre Verifizierung dort fort, wo Sie aufgehört haben.', 'Request your secure access link and continue your verification where you left off.')}
          </p>
        </div>
      </div>

      <div className="card portal-login-card">
        <form onSubmit={handleSubmit} className="form-grid">
          <label className="full-width">
            {ui('E-Mail-Adresse', 'Email address')}
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
              required
            />
          </label>

          {message ? <div className="success-box full-width">{message}</div> : null}
          {error ? <div className="hint-box full-width">{error}</div> : null}

          <button type="submit" className="primary-button full-width" disabled={submitting}>
            {submitting ? ui('Zugangslink wird versendet...', 'Sending access link...') : ui('Sicheren Zugangslink anfordern', 'Request secure access link')}
          </button>
        </form>
      </div>
    </main>
  );
}

export function PortalLoginConsume() {
  const { loginToken } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const consumeToken = async () => {
      try {
        const response = await fetch(`${API_URL}/portal/login/${encodeURIComponent(loginToken)}`, {
          method: 'POST',
        });
        const payload = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(payload.error || ui('Login-Link ist ungültig oder abgelaufen.', 'The login link is invalid or has expired.'));
        }

        if (!cancelled) {
          navigate(payload.redirect_url || `/portal/${encodeURIComponent(payload.portal_token)}`, { replace: true });
        }
      } catch (err) {
        console.error(err);
        if (!cancelled) {
          setError(err.message || ui('Login-Link ist ungültig oder abgelaufen.', 'The login link is invalid or has expired.'));
        }
      }
    };

    consumeToken();

    return () => {
      cancelled = true;
    };
  }, [loginToken, navigate]);

  return (
    <main className="page-shell portal-login-page">
      <div className="card portal-login-card">
        {error ? (
          <>
            <p>{normalizeMessage(error)}</p>
            <Link className="primary-link-button" to="/portal">
              {ui('Neuen Zugangslink anfordern', 'Request a new access link')}
            </Link>
          </>
        ) : (
          <p>{ui('Ihr Zugangslink wird geprüft...', 'Checking your access link...')}</p>
        )}
      </div>
    </main>
  );
}

